import { offerValue } from "@components/ui/offer/types/offerValue"

interface BuildOfferPropsParams {
    uuid: string;
    title?: string;
    company?: string;
    jobType?: string;
    workPlace?: string;
    location?: string;
    description?: string;
    requirement?: string;
    salary?: string;
    status?: string;
    tag?: any,
    category?: string;
    recruiter?: string | number;
    recruiterEmail?: string;
    targetCountryAFRICA?: boolean;
    targetCountryIN?: boolean;
    targetCountryMG?: boolean;
}

export const buildOfferProps = ({
    uuid,
    title,
    company,
    jobType,
    workPlace,
    location,
    description,
    requirement,
    salary,
    status,
    tag,
    recruiter,
    recruiterEmail,
    category,
    targetCountryAFRICA,
    targetCountryIN,
    targetCountryMG
}: BuildOfferPropsParams) => {
    return {
        "uuid": uuid,
        [offerValue.group]: {
            [offerValue.subGroup.information]: {
                [offerValue.field.title]: title,
                [offerValue.field.company]: company,
                [offerValue.field.jobType]: jobType,
                [offerValue.field.workPlace]: workPlace,
                [offerValue.field.location]: location,
                [offerValue.field.description]: description,
                [offerValue.field.requirement]: requirement,
                [offerValue.field.salary]: salary,
                [offerValue.field.status]: status,
                [offerValue.field.tag]: tag,
                [offerValue.field.recruiter]: recruiter,
                [offerValue.field.recruiterEmail]: recruiterEmail,
                [offerValue.field.category]: category
            },
            [offerValue.subGroup.targetCountry]: {
                [offerValue.field.targetCountryAFRICA]: targetCountryAFRICA,
                [offerValue.field.targetCountryIN]: targetCountryIN,
                [offerValue.field.targetCountryMG]: targetCountryMG
            }
        }
    }
}